import dayjs from "dayjs";

require("dayjs/locale/pt-br");
dayjs.locale("pt-br");

export default dayjs;
